import { renderLabelWithDescriptionLineLayoutTemplate } from '@next-adapter/templates/renderers/generators/form-pipeline/form-component-shared/label-with-description-line.js'
export function labelWithDescriptionLine(
  labelJSX: string,
  descriptionJSX: string,
  indent: string
): string {
  if (!descriptionJSX) return labelJSX
  return renderLabelWithDescriptionLineLayoutTemplate({
    indent: indent,
    labelJsx: labelJSX,
    descriptionJsx: descriptionJSX
  })
}
